export default "__VITE_ASSET__BWzO_qkk__"